import { isClient } from "@smile2impress/attraction-utils";

export const isClientFromMedicare = () =>
    isClient() &&
    new URLSearchParams(window.location.search).get("from") === "medicare";
